import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { FormItemName } from '../../../../lib/models/Form';
import { FormItem } from '../../../../components/FormItem';
import { FormInput } from '../../../../components/FormInput';

const clientAddress = 'unique.formItems.clientAddress';

export const ClientAddressFormItem: FC = () => {
  const { t } = useTranslation();

  return (
    <FormItem
      name={FormItemName.CLIENT_ADDRESS}
      hasFeedback={true}
      rules={[
        {
          required: false,
        },

        { max: 100 },
      ]}
    >
      <FormInput label={t(`${clientAddress}.label`)} />
    </FormItem>
  );
};
